import {GET_OFFER_LETTER_LIST, GET_OFFER_LETTER_LIST_SUCCESS,GET_OFFER_LETTER_LIST_FAILED} from './actionTypes'

 
 
 const initialState = {
    loading: false,
    offerLettersList: null ,
    errorMessage: null,
    
 }
 
 const OfferLetterListReducer = (state = initialState, action) => {
 
   switch (action.type) {
     case GET_OFFER_LETTER_LIST:
       state = {
         ...state,
         loading: true,
         offerLettersList: null ,
         errorMessage: null
       }
       break
     case GET_OFFER_LETTER_LIST_SUCCESS:
       state = {
         ...state,
         loading: false,
         offerLettersList: action.payload ,
         errorMessage: null
       }
       break
     case GET_OFFER_LETTER_LIST_FAILED:
 
       state = {
         ...state,
         loading: false,
         offerLettersList: null ,
         errorMessage: action.payload
       }
       break
      
     default:
       state = { ...state }
       break
   }
   return state
 }
 
 export default OfferLetterListReducer
 